// Universal principle checks — applied to any move regardless of opening,
// to catch beginner mistakes like early queen sorties and flank pawn pushes.
export const UNIVERSAL_PRINCIPLES = {
  // Ply number below which these apply
  openingPlies: 20,

  // Early queen development (moving the queen more than once or too early)
  earlyQueenSquares: {
    white: new Set(["a4", "b5", "c4", "c5", "d5", "e5", "f3", "f5", "g4", "h4", "h5", "a5", "b4"]),
    black: new Set(["a5", "b4", "c5", "c4", "d4", "e4", "f6", "f4", "g5", "h5", "h4", "a4", "b5"]),
  },

  // Flank pawn moves in the opening (a/h files) generally unhelpful
  flankPawnFiles: new Set(["a", "h"]),
};
